import { connectBaseApi, createRpcQuery, createRpcMutation, truckClient } from "@racoon/api";

const truckTypeApi = connectBaseApi.injectEndpoints({
  endpoints: (build) => ({
    listTruckTypes: createRpcQuery(build, truckClient, "listTruckTypes", {
      providesTags: ["TruckType"],
    }),
    getTruckTypeById: createRpcQuery(build, truckClient, "getTruckTypeById", {
      providesTags: ["TruckType"],
    }),
    createTruckType: createRpcMutation(build, truckClient, "createTruckType", {
      invalidatesTags: ["TruckType"],
    }),
    updateTruckType: createRpcMutation(build, truckClient, "updateTruckType", {
      invalidatesTags: ["TruckType"],
    }),
    deleteTruckType: createRpcMutation(build, truckClient, "deleteTruckType", {
      invalidatesTags: ["TruckType"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListTruckTypesQuery,
  useGetTruckTypeByIdQuery,
  useCreateTruckTypeMutation,
  useUpdateTruckTypeMutation,
  useDeleteTruckTypeMutation,
} = truckTypeApi;
